import React, { useState, useEffect } from 'react';
import 'react-autosuggest';
import { ComboBox, DefaultButton, Dialog, DialogFooter, DialogType, IconButton, PrimaryButton, TextField } from '@fluentui/react';
import { Accordion } from '../../../controles/Accordion/Accordion';
import '../PlanificacionProyecto.css';
import { ClickAwayListener } from '@material-ui/core';
import NumberFormat from 'react-number-format';

interface Props {
    actividadesList?: IngresoTerceros[];
    ingresoP?: IngresoData[];
    callback: any;
    moneda?: string;
    callbackActividades: any;
    moneda_ctto: string;
}

interface IngresoTerceros {
    ID_SIMULACION: number;
    ID_MODULO: number;
    ID_ACTIVIDAD: number;
    index: number;
    NOMBRE: string;
    TOTAL_COSTO: number;
    TOTAL_INGRESO: number;
    TOTAL_RENTABILIDAD: number;
}

interface IngresoData {
    INDEX: number;
    ID_SIMULACION: number;
    ID_ACTIVIDAD: number;
    ITEM: string;
    UNIDAD: string;
    COSTO_UNITARIO: number;
    CANTIDAD:   number;
    COSTO_TOTAL:number;
    MARGEN: number;
    INGRESO:number;
    RENTABILIDAD: number;
}

//const addRol = (e: any, actividadID: number, index: number) => {

//}

const IngresosTercerosVenta = ({ actividadesList, ingresoP, callback, 
    moneda, callbackActividades, moneda_ctto}: Props) => {

    //console.log(actividadesList);

    const [ingresos, setIngreso] = useState(ingresoP);
    const [actividades, setActividades] = useState(actividadesList);
    const [nombreAcividad, setNombreActividad] = useState("");

    const [costoTotal, setCostoTotal] = useState(0);
    const [ingresoTotal, setingresoTotal] = useState(0);
    const [rentabilidadTotal, setRentabilidadTotal] = useState(0);

    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogSubText, setDialogSubText] = useState("");

    const [indexActividad, setIndexActividad] = useState(-1);
    const [indexIngreso, setIndexIngreso] = useState(-1);

    const [activeKey, setActiveKey] = useState(0);
    const modalPropsStyles = { main: { maxWidth: 450 } };
    const modalProps = React.useMemo(
        () => ({
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: undefined,
        }),
        [],
    );
    const [hideDialog, setDialog] = useState(true);
    const dialogContentProps = {
        type: DialogType.normal,
        title: dialogTitle,
        subText: dialogSubText,
    };

    const addActividad = () => {
        let actividad = actividades;

        if(nombreAcividad != ""){
            if (actividad != undefined) {
                actividad.push({
                    ID_SIMULACION: 0,
                    ID_MODULO: 2,
                    ID_ACTIVIDAD: actividad.length + 1,
                    index: actividad.length,
                    NOMBRE: nombreAcividad,
                    TOTAL_COSTO: 0,
                    TOTAL_INGRESO: 0,
                    TOTAL_RENTABILIDAD: 0,
                });
                setActividades([...actividad]);
                callbackActividades(actividades);
            }
        }else{
            //errorActividad
        }

        setNombreActividad("");
    }

    const addRol = (actividadID: number) => {
        //console.log(ingresos);
        let ingreso = ingresos;

        if (ingreso != undefined) {
            ingreso.push({
                ID_ACTIVIDAD: actividadID,
                ID_SIMULACION: 0,
                ITEM: "",
                UNIDAD: "",
                COSTO_UNITARIO: 0,
                CANTIDAD: 0,
                COSTO_TOTAL: 0,
                MARGEN: 0,
                INGRESO: 0,
                RENTABILIDAD: 0,
                INDEX: ingreso.reduce((a: number, b: IngresoData) => 1 + b.INDEX, 0)
            });
            setIngreso([...ingreso]);
            callback(ingreso);
        }
    }

    const deleteRol = (indexI: number) => {
        let ingreso = ingresos;

        if (ingreso != undefined) {
            let row = ingreso.find((ing: IngresoData, i: number) => i === indexI);
            let sumaRows = 0;
            if (row != undefined) {
                sumaRows = row.MARGEN + row.CANTIDAD + row.COSTO_UNITARIO;
            }

            if (sumaRows === 0) {
                ingreso.splice(indexI, 1);
                setIngreso([...ingreso]);
                //console.log(ingreso);
                callback(ingreso);
            } else {
                // alert("esta fila tiene datos!");
                setDialogTitle("Ingreso con datos!");
                setDialogSubText("Esta fila contiene datos ingresados ¿Está seguro que desea eliminar?");
                setIndexIngreso(indexI);
                setDialog(false);
            }
        }
    }

    const deleteRolIndex = () => {
        let ingreso = ingresos;

        if (ingreso != undefined) {
            ingreso.splice(indexIngreso, 1);
            setIngreso([...ingreso]);
            //console.log(ingreso);
            setIndexIngreso(-1);
            setIndexActividad(-1);
            setDialog(true);
            callback(ingreso);
            // ingreso.forEach((ing, i) => {
            //     if (i === indexIngreso) {
            //         if (ingreso != undefined) {
            //             ingreso.splice(indexIngreso);
            //             setIngreso([...ingreso]);
            //             setIndexIngreso(-1);
            //             setIndexActividad(-1);
            //             setDialog(true);
            //         }
            //     }
            // });
        }
    }

    const deleteActividad = (actividadID: number, indexA: number) => {
        let ingreso = ingresos;
        let actividad = actividades;
        let tieneIngresos = false;

        if (ingreso != undefined) {
            tieneIngresos = ingreso.some((i: IngresoData) => i.ID_ACTIVIDAD === actividadID);
        }

        if (tieneIngresos) {
            // alert("No puede eliminar porque tiene items adentro!");
            setIndexActividad(indexA);
            setDialogTitle("Actividad con roles!");
            setDialogSubText("¿Está seguro que desea eliminar la actividad?");
            setDialog(false);
        } else {
            if (actividad != undefined) {
                actividad.splice(indexA, 1);
                setActividades([...actividad]);
                callbackActividades(actividades);
            }
        }
    }

    const deleteActividadRoles = () => {
        let ingreso = ingresos;
        let actividad = actividades;
        let actividadEliminar: IngresoTerceros | undefined;

        if (actividad != undefined) {

            actividadEliminar = actividad.find((a, i) => i === indexActividad);

            if (ingreso != undefined) {
                let ingEliminar: number[];
                if (actividadEliminar != undefined) {
                    let idActividad = actividadEliminar.ID_ACTIVIDAD;
                    ingreso.forEach((ing: IngresoData, i: number) => {
                        if (ing.ID_ACTIVIDAD === idActividad) {
                            if (ingreso != undefined) {
                                ingreso.splice(i, 1);
                            }
                        }
                    });
                }

                actividad.splice(indexActividad, 1);
                setIndexActividad(-1);
                setActividades([...actividad]);
                setIngreso([...ingreso]);
                setDialog(true);
                callback(ingreso);
            }
        }
    }

    const onValueChanged = (index: number, ev: any, indexA: number) => {
        let key = ev.target.id;
        let value = ev.target.value;
        //console.log(index, indexA, value, key);

        let data = ingresos;
        if (data != undefined) {
            data.map((i: IngresoData, ing: number) => {
                if (index === ing) {
                    switch (key) {
                        case "unidadTerceros":
                            i.UNIDAD = value;
                            break;
                        case "costoUnitarioTerceros":
                            i.COSTO_UNITARIO = parseFloat(value);
                            //Calcular
                            break;
                        case "cantidadTerceros":
                            i.CANTIDAD = parseFloat(value);
                            //Calcular
                            break;
                        case "costoTotalTerceros":
                            i.COSTO_TOTAL = parseFloat(value);
                            break;
                        case "margenTerceros":
                            i.MARGEN = parseFloat(value);
                            //Calcular
                            break;
                        case "ingresoTerceros":
                            i.INGRESO = parseFloat(value);
                            break;
                        case "itemTerceros":
                            i.ITEM = value;
                            break;
                        case "rentabilidadTerceros":
                            i.RENTABILIDAD = parseFloat(value);
                            //Calcular
                            break;
                    }
                    i.COSTO_TOTAL = parseFloat(((i.CANTIDAD) * (i.COSTO_UNITARIO)).toFixed(2));
                    i.INGRESO = parseFloat(((i.COSTO_TOTAL) * (1 + (i.MARGEN) / 100)).toFixed(2));
                    i.RENTABILIDAD = parseFloat((((i.INGRESO - i.COSTO_TOTAL) / i.INGRESO) * 100) .toFixed(2));
                }
            });

            //Total Actividad
            calcularTotalActividad(data, indexA);



            setIngreso([...data]);
            callback(data);
        }
    }

    const calcularTotalActividad = (ingresos: IngresoData[], actividadID: number) => {
        if (ingresos != undefined) {
            let ingresosAct = ingresos.filter(i => { return i.ID_ACTIVIDAD === actividadID });
            let actividadesCopy = actividades;
            let total_ingresos = 0;
            let total_costo = 0;
            if (actividadesCopy != undefined) {
                //let act = actividadesCopy.find(a => a.actividadID === actividadID);
                actividadesCopy.forEach(a => {
                    if (a.ID_ACTIVIDAD === actividadID) {
                        a.TOTAL_COSTO = parseFloat(ingresosAct.reduce((a, b) => a + b.COSTO_TOTAL, 0).toFixed(2));
                        a.TOTAL_INGRESO = parseFloat(ingresosAct.reduce((a, b) => a + b.INGRESO, 0).toFixed(2));
                        a.TOTAL_RENTABILIDAD = parseFloat((((((a.TOTAL_INGRESO - a.TOTAL_COSTO) / a.TOTAL_INGRESO)) * 100)).toFixed(2));
                    }
                });

                //actualizar totales
                total_ingresos = actividadesCopy.reduce((a, b) => a + b.TOTAL_INGRESO, 0);
                total_costo = actividadesCopy.reduce((a, b) => a + b.TOTAL_COSTO, 0);

                setCostoTotal(actividadesCopy.reduce((a, b) => a + b.TOTAL_COSTO, 0));
                setingresoTotal(actividadesCopy.reduce((a, b) => a + b.TOTAL_INGRESO, 0));

                setRentabilidadTotal(parseFloat((((((total_ingresos - total_costo) / total_ingresos)) * 100)).toFixed(2)));

                setActividades([...actividadesCopy]);
            }
        }
    }

    document.onclick = () => {
        /* let data = ingresos;
            data!.map((a:any) => {
            //console.log(a);
            calcularTotalActividad(data!, a.ID_ACTIVIDAD);
            }) */
    }

    useEffect(() => {
        let data = ingresos;
            data!.map((a:any) => {
            //console.log(a);
            calcularTotalActividad(data!, a.ID_ACTIVIDAD);
            })
    }, []);
    

    const FilasIngresos = (a: IngresoTerceros) => {
        return (
            <div>
                {
                    ingresos != undefined ? ingresos.map((i: IngresoData, indexI: number) => {
                        //console.log(i)
                        return (
                            <div>
                                {
                                    i.ID_ACTIVIDAD === a.ID_ACTIVIDAD ?
                                        <div>
                                            <div key={indexI}>
                                                <div className="ms-Grid-row bloqueActividad" id="bloqueActividad">
                                                <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 txtSmall">
                                                    <TextField
                                                        label="Ítem"
                                                        id={"itemTerceros"}
                                                        defaultValue={i.ITEM}
                                                        placeholder="Nombre ítem"
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2 txtSmall">
                                                    <TextField
                                                        label="Unidad"
                                                        id={"unidadTerceros"}
                                                        defaultValue={i.UNIDAD}
                                                        placeholder="..."
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="Costo unitario"
                                                        id={"costoUnitarioTerceros"}
                                                        defaultValue={i.COSTO_UNITARIO === 0 ? "" : new Intl.NumberFormat('de-DE').format(i.COSTO_UNITARIO).toString()}
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="Cantidad"
                                                        id={"cantidadTerceros"}
                                                        defaultValue={i.CANTIDAD === 0 ? "" : new Intl.NumberFormat('de-DE').format(i.CANTIDAD).toString()} 
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="Costo total"
                                                        disabled={true}
                                                        id={"costoTotalTerceros"}
                                                        value={i.COSTO_TOTAL === 0 ? "" : new Intl.NumberFormat('de-DE').format(i.COSTO_TOTAL)} 
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        //type={"number"}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="% Sobre Costos"
                                                        id={"margenTerceros"}
                                                        defaultValue={i.MARGEN === 0 ? "" : i.MARGEN.toString() + "%"}
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="Ingreso"
                                                        disabled={true}
                                                        id={"ingresoTerceros"}
                                                        value={i.INGRESO === 0 ? "" : new Intl.NumberFormat('de-DE').format(i.INGRESO)}
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        //type={"number"}
                                                    />
                                                </div>
                                                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 txtSmall">
                                                    <TextField
                                                        label="Rentabilidad (%)"
                                                        id={"rentabilidadTerceros"}
                                                        disabled={true}
                                                        value={i.RENTABILIDAD === 0 ? "" : new Intl.NumberFormat('de-DE').format(i.RENTABILIDAD).replace(".", ",") + "%"}
                                                        onChange={(e) => { onValueChanged(indexI, e, i.ID_ACTIVIDAD) }}
                                                        //type={"number"}
                                                    />
                                                </div>
                                                {/* <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 mt-4" id="divEliminarRol">
                                                    <button id="btnAgregarRol" onClick={(e) => { deleteRol(indexI) }}><i className="ms-Icon ms-Icon--Delete" aria-hidden="true" id="btnEliminarRol"></i></button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                        : ""
                                }
                            </div>
                        );

                    })
                        : ""
                }

                <div className="ms-Grid-row bloqueActividad" id="bloqueActividad">
                    {/* <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2" id="divAgregarActividad">
                        <button id="btnAgregarRol" onClick={(e) => { addRol(a.ID_ACTIVIDAD) }}><i className="ms-Icon ms-Icon--AddTo" aria-hidden="true" id="btnAgregarRol"><span className="txtAgregar">&nbsp; Agregar ítem</span></i></button>
                    </div> */}
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"></div>
                    <div className="ms-Grid-col ms-sm7 ms-md7 ms-lg7" id="divTotal">Total</div>
                    <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1 pb-1">
                        <TextField
                            id={"totalActividadTercerosCostoTotal"}
                            disabled={true}
                            placeholder={"..."}
                            //type={"number"}
                            value={a.TOTAL_COSTO != undefined ? new Intl.NumberFormat('de-DE').format(a.TOTAL_COSTO) : ""}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1"></div>
                    <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                        <TextField
                            id={"totalActividadTercerosIngreso"}
                            disabled={true}
                            placeholder={"..."}
                            //type={"number"}
                            value={a.TOTAL_INGRESO != undefined ? new Intl.NumberFormat('de-DE').format(a.TOTAL_INGRESO) : ""}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                        <TextField
                            id={"totalActividadTercerosRentabilidad"}
                            disabled={true}
                            placeholder={"..."}
                            //type={"number"}
                            value={a.TOTAL_RENTABILIDAD != undefined ? new Intl.NumberFormat('de-DE').format(a.TOTAL_RENTABILIDAD).replace(".", ",") + "%" : ""}
                        />
                    </div>
                </div>
            </div>
        );
    }

    const Resumen = () => {
        return (
            <div className="ms-Grid-row divTotalBloque" id="divTotalBloque">
                <div className="ms-Grid-col ms-sm7 ms-md7 ms-lg7" id="divTotal">Total servicios terceros</div>
                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                    <TextField
                        id={"totalBloqueTerceroCostoTotal"}
                        disabled={true}
                        placeholder={"..."}
                        //type={"number"}
                        value={costoTotal != undefined ? new Intl.NumberFormat('de-DE').format(costoTotal) : ""}
                    />
                </div>
                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1"></div>
                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                    <TextField
                        id={"totalBloqueTerceroIngreso"}
                        disabled={true}
                        placeholder={"..."}
                        //type={"number"}
                        value={ingresoTotal != undefined ? new Intl.NumberFormat('de-DE').format(ingresoTotal) : ""}
                    />
                </div>
                <div className="ms-Grid-col ms-sm1 ms-md1 ms-lg1">
                    <TextField
                        id={"totalBloqueTerceroRentabilidad"}
                        disabled={true}
                        placeholder={"..."}
                        //type={"number"}
                        value={rentabilidadTotal != undefined ? new Intl.NumberFormat('de-DE').format(rentabilidadTotal).replace(".", ",") + "%" : ""}
                    />
                </div>
            </div>
        );
    }

    const Actividades = () => {
        return (
            actividades != undefined ? actividades.map((a: IngresoTerceros, indexA: number) => {
                return (
                    <div>
                        <div>

                            <div className="acordeonActividad">
                                <Accordion title={a.NOMBRE}
                                    defaultCollapsed={false} inicio={true} expandAll={false} className="fondoTitAcordionActividad" key={1} classFondo="fondoSeccionActividad">
                                    <div className="itemContent">
                                        {/* <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" id="divBloque">
                                            <button id="btnAgregarRol" className="cierre" onClick={(e) => { deleteActividad(a.ID_ACTIVIDAD, indexA) }}><i className="ms-Icon ms-Icon--Cancel" aria-hidden="true" id="btnEliminarActividad"></i></button>
                                        </div> */}
                                    </div>
                                    {FilasIngresos(a)}
                                </Accordion>
                            </div>

                        </div>
                    </div>);
            })
                : ""
        );
    }

    const dialog = () => {
        return (
            <Dialog
                hidden={hideDialog}
                onDismiss={() => { setDialog(true) }}
                dialogContentProps={dialogContentProps}
                modalProps={modalProps}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => { indexIngreso > -1 ? deleteRolIndex() : deleteActividadRoles() }} text="Sí, Eliminar" />
                    <DefaultButton onClick={() => { setDialog(true) }} text="No" />
                </DialogFooter>
            </Dialog>

        );
    }

    return (
        <React.Fragment>
            <div className="ms-Grid" dir="ltr">
                <div className="acordeon">
                    {/* <Accordion title="Ingresos y costos directos"
                        defaultCollapsed={true} inicio={true} expandAll={false} className="fondoTitAcordion" key={1} classFondo="fondoSeccion"> */}
                    <div className="itemContent">
                        <div className="ms-Grid-row">
                            {/* <div className="ms-Grid-col ms-sm8 ms-md4 ms-lg4 mt-2 mb-2">
                                <TextField
                                    placeholder="Nombre Actividad"
                                    id={"nombreActividadDirecto"}
                                    //value={this.state.nombreActividad}
                                    onChange={(e: any) => { setNombreActividad(e.target.value) }}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm1 ms-md3 ms-lg3 mt-2 mb-2" id="divAgregarActividad">
                                <button id="btnAgregarActividad" className="btnAgregarActividad" onClick={(e) => { addActividad() }}>
                                    <i className="ms-Icon ms-Icon--AddTo" aria-hidden="true" id="btnAgregarActividad">&nbsp;
                                        <span className="txtAgregar">Agregar Actividad</span>
                                    </i>
                                </button>
                            </div> */}
                            <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8"></div>
                            <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 d-flex justify-content-end mt-3">
                                <label>Los valores reflejados están en la moneda del Contrato Marco: <span>{moneda_ctto}</span></label>
                            </div>
                        </div>
                        {
                            Actividades()
                        }
                        {
                            dialog()
                        }
                        {
                            Resumen()
                        }
                    </div>
                    {/* </Accordion> */}
                </div>
            </div>
        </React.Fragment >
    );
}

export default IngresosTercerosVenta;
